module.exports = __webpack_public_path__ + "static/img/vaccine-active.94461e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/vaccine-active.png
// module id = Z/Pu
// module chunks = 58